import { apiClient } from "@/lib/api/client";
import { IRepository } from "./types";
import {
  StMultyPropertyTypes,
  StMultyPropertyTypesInsert,
  StMultyPropertyTypesUpdate,
} from "@/types";

class StMultyUnitPropertyTypesRepository
  implements
    IRepository<
      StMultyPropertyTypes,
      StMultyPropertyTypesInsert,
      StMultyPropertyTypesUpdate
    >
{
  private static instance: StMultyUnitPropertyTypesRepository;
  private readonly endpoint: string;

  constructor(endpoint: string = "stays-multy-unit-types") {
    this.endpoint = endpoint;
  }

  public static getInstance(): StMultyUnitPropertyTypesRepository {
    if (!this.instance) {
      this.instance = new StMultyUnitPropertyTypesRepository();
    }
    return this.instance;
  }

  async getAll(_params?: unknown): Promise<StMultyPropertyTypes[]> {
    return apiClient.invoke<StMultyPropertyTypes[]>(this.endpoint, {
      method: "GET",
    });
  }

  async getById(id: string): Promise<StMultyPropertyTypes | null> {
    return apiClient.invoke<StMultyPropertyTypes>(`${this.endpoint}?id=${id}`, {
      method: "GET",
    });
  }
}

export const stMultyUnitPropertyTypesRepository =
  StMultyUnitPropertyTypesRepository.getInstance();
